import { getBreadcrumbTrail } from '@fm-nx/navigation';
import { Icon } from '@fm-nx/svg';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

type BreadcrumbProps = {
    title?: string | null;
};

export function Breadcrumb(props: BreadcrumbProps) {
    const { title } = props;
    const pathname = usePathname();
    const trail = useMemo(() => {
        return getBreadcrumbTrail({ pathname }) ?? [];
    }, [pathname]);

    if (pathname === '/') {
        return null;
    }

    return (
        <div className="flex flex-row gap-2 items-center">
            <Link className="leading-4" href={'/'}>
                <Icon name="home" />
            </Link>
            {trail.map((segment) => (
                <span key={segment.href} className="h5 overline">
                    <Link href={segment.href}>{segment.label}</Link>
                </span>
            ))}
            <h1 className="h5 overline hidden md:inline-flex">{title}</h1>
        </div>
    );
}

export default Breadcrumb;
